module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "P_TOC_Heading"
  }, [_c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")])]), _c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }), _c('a', {
    attrs: {
      "href": "#/section0001"
    }
  }, [_vm._v("Title")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0002"
    }
  }, [_vm._v("Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0003"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0004"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0005"
    }
  }, [_vm._v("Author Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0006"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0007"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0008"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0009"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/section0010"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourth Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1",
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional Titles")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a74fbdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableOfContents.vue
// module id = 60
// module chunks = 0